<template>
  <div v-a11y-tab:tab-line>
    <router-link :to="path" class="off-default-focus">
      <div class="logo"></div>
    </router-link>
  </div>
</template>

<script>
import { ROUTER_PATHS } from '@/router/constants';

export default {
  computed: {
    path() {
      return ROUTER_PATHS.HOME;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.logo {
  height: $logo-height;
  width: $logo-width;
  background: transparent url('~@/assets/icons/logo.svg') center no-repeat;
}

@media (max-width: $page-mobile-large-breakpoint) {
  .logo {
    background-size: 110px;
  }
}
</style>
